<div class="tab-content" [hidden]="!selected">
    <ng-content></ng-content>
</div>
